import axiosInstance from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// POST admin/legal_policy_create
// POST admin/legal_polcy_list
// POST /v3/legal_policy_get (requires type in body)

//* GET All Legal Agreements
export const getLegalAgreementsList = async () => {
  let response = {};

  try {
    response = await axiosInstance.post(`/admin/legal_policy_list`);
    console.log('response:', response);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* GET Single Legal Agreement by ID
export const getLegalAgreement = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/v3/legal_policy_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* POST Create new Legal Agreement
export const createLegalAgreement = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/admin/legal_policy_create`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// //* PUT Update existing Legal Agreement
// export const updateLegalAgreement = async (payload) => {
//   let response = {};

//   try {
//     response = await axiosInstance.post(`/admin/update_ai_config`, payload);
//     return response;
//   } catch (error) {
//     return handleApiError(error);
//   }
// };

//* DELETE Legal Agreement
export const deleteLegalAgreement = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/admin/legal_policy_delete`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
